// extracted by mini-css-extract-plugin
export default {"returnsAndExchangesUPSPickUpAddress":"L4-z","columnTitle":"M4-z","addressDetails":"N4-z"};